//base urls

export const employeeShowProfile = `employee/show-profile`;
export const employeeProfileSettings = `employee/profile-form-settings?branchId=`;
export const appliedJob = `employee/applied-job?position_number=`;
export const employeeCancelAPplication = `employee/cancel-application`;
export const employeeUpdateResume = `employee/update-resume`;
export const questionnaireFileUpload = `employee/file-upload?param=questionnaire_file`;
export const employeeApplyJob = `employee/apply-job`;
export const uploadProfilePic = `employee/upload-profile-pic`;
export const saveProfile = `employee/save-profile`;
export const downloadResume = `employee/download-resume`;
export const employeeAppliedJobs = `employee/applied-jobs`;
export const openingJobs = 'jobs';
export const baseProfile = 'profile/';
export const baseUserDetails = 'users/userDetails/';
export const userAccess = 'users/app/permissions/WFM/';
export const essBasicDetailsGet = 'basicDetails/ess/user/';
